export default class PipManager {
}
//# sourceMappingURL=pip-manager.js.map